import { z } from 'zod';
import { projectsProjectSummarySchema } from './projects-project.contract.js';
export const projectsReportingProjectIndexCapability = 'projects.reporting-project-index.v1';
export const projectsReportingProjectIndexSlot = 'reporting.projects-index';
export const projectsReportingProjectIndexProviderId = 'projects.server.reporting-project-index';
export const projectsReportingProjectIndexRequestSchema = z.strictObject({
    consumerModuleId: z.literal('reporting'),
    requestedCapability: z.literal('reporting.finance-project-performance.v1'),
    resourceType: z.literal('reporting.dataset'),
    resourceId: z.string().uuid(),
    maximumProjects: z.number().int().min(1).max(500),
});
export const projectsReportingProjectSchema = projectsProjectSummarySchema.pick({
    id: true,
    projectNumber: true,
    name: true,
    status: true,
    revision: true,
    createdAt: true,
    updatedAt: true,
});
export const projectsReportingProjectIndexResponseSchema = z.strictObject({
    contractVersion: z.literal(projectsReportingProjectIndexCapability),
    tenantId: z.string().uuid(),
    totalProjects: z.number().int().nonnegative(),
    truncated: z.boolean(),
    projects: z.array(projectsReportingProjectSchema).max(500),
}).superRefine((response, context) => {
    if (response.projects.length > response.totalProjects ||
        response.truncated !== (response.projects.length < response.totalProjects)) {
        context.addIssue({
            code: 'custom', path: ['totalProjects'],
            message: 'Reporting Project totals and truncation must reconcile.',
        });
    }
    const ids = response.projects.map(({ id }) => id);
    if (new Set(ids).size !== ids.length) {
        context.addIssue({ code: 'custom', path: ['projects'], message: 'Projects cannot repeat.' });
    }
});
//# sourceMappingURL=projects-reporting-project-index.contract.js.map